var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion6 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13a1 1 0 0 1-1-1v-1.027c0-1.41 1.124-2.477 2.212-3.509C10.091 6.63 11 5.767 11 5c0-1.493-1.082-3-3.5-3a3.494 3.494 0 0 0-3.479 3.11 1 1 0 1 1-1.988-.22 5.5 5.5 0 0 1 1.785-3.477A5.5 5.5 0 0 1 7.499 0c1.475 0 2.834.463 3.828 1.305 1.078.913 1.672 2.225 1.672 3.695 0 1.626-1.281 2.842-2.411 3.915-.745.707-1.589 1.508-1.589 2.058V12a1 1 0 0 1-1 1zM9 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question6.svg";